export const it = {
  video: {
    startDialog: {
      start: 'Guarda ora',
      resume: 'Riprendi il video',
      restart: 'Rivedi il video',
      questions: '{{questions}} Domande',
      duration: '{{time}} min',
      credits: '{{credits}} Crediti',
      colleaguesHint: {
        singular: 'Un altro tuo collega ha già video il video, non restare indietro!',
        plural: 'Oltre {{colleagues}} colleghi hanno già visto il video, non restare indietro!',
      },
      errors: {
        noCredits: 'Non hai crediti sufficienti per iniziare il video.',
      },
    },
    confirmExitFromVideoDialog: {
      title: 'Esci dal video',
      description:
        'Se chiudi il video ora, potrai riprenderlo in qualsiasi momento dal punto in cui lo hai lasciato',
      adminDescription:
        'Se chiudi il video adesso, non potrai riprendere dal punto in cui hai interrotto, ma potrai rivederlo tutte le volte che vuoi dall’inizio',
      confirm: 'Esci',
      cancel: 'Annulla',
    },
    feedbackVideoDialog: {
      title: 'Come valuti questo video?',
      submittedTitle: 'Grazie per il tuo feedback!',
      description: 'La valutazione è facoltativa.',
      commentPlaceholder: 'Lascia un commento per farci sapere la tua esperienza',
      submittedDescription:
        'Prosegui con il training per non perderti i prossimi contenuti disponibili!',
      confirm: 'Invia',
      backToTraining: 'Torna al training',
    },
  },
};
